module.exports = __webpack_public_path__ + "static/media/connected.ad587cef.svg";